import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  textColor?: 'default' | 'white';
}

const Logo: React.FC<LogoProps> = ({ size = 'md', showText = true, className = '', textColor = 'default' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20'
  };

  const textSizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-xl',
    xl: 'text-2xl'
  };

  const textColorClasses = {
    default: 'text-blue-800',
    white: 'text-white'
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Logo Icon */}
      <div className={`${sizeClasses[size]} relative`}>
        <img
          src="/images/cloudIngiteLogo.png"
          alt="CloudIgnite Logo"
          className="w-full h-full object-contain"
          onError={(e) => {
            // Fallback to SVG if image fails to load
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            target.nextElementSibling?.classList.remove('hidden');
          }}
        />
        {/* Fallback SVG */}
        <svg viewBox="0 0 100 100" className="w-full h-full hidden">
          {/* Blue Gear Background */}
          <path
            d="M50 10 L60 20 L70 20 L75 30 L85 35 L80 45 L85 55 L75 60 L70 70 L60 70 L50 80 L40 70 L30 70 L25 60 L15 55 L20 45 L15 35 L25 30 L30 20 L40 20 Z"
            fill="#1E40AF"
            stroke="#1E40AF"
            strokeWidth="2"
          />
          
          {/* White Cloud */}
          <path
            d="M25 45 Q25 35 35 35 Q40 25 50 25 Q60 25 65 35 Q75 35 75 45 Q75 55 65 55 L35 55 Q25 55 25 45 Z"
            fill="white"
            stroke="#1E40AF"
            strokeWidth="1"
          />
          
          {/* White Crescent */}
          <path
            d="M35 30 Q40 25 45 30 Q50 35 45 40 Q40 35 35 30 Z"
            fill="white"
          />
        </svg>
      </div>
      
      {/* Logo Text */}
      {showText && (
        <span className={`font-bold ${textColorClasses[textColor]} ${textSizes[size]}`}>
          CloudIgnite
        </span>
      )}
    </div>
  );
};

export default Logo; 